<template>
  <div id="app">
    <HeaderComponent />
    <router-view> </router-view>
    <FooterComponent />
  </div>
</template>

<script>
import HeaderComponent from "./components/HeaderComponent.vue";
import FooterComponent from './components/FooterComponent.vue'

export default {
  components: {
    HeaderComponent,
    FooterComponent
  },
};
</script>

<style lang="scss">
@import url("./assets/all.scss");
</style>
